var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPowerPoint = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8162 13.2002L14.0162 0H13.8818C7.33642 0.0191087 2.0351 5.32043 2.01599 11.8658V12.0002L15.8162 13.2002Z",
    fill: "#ED6C47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1521 0H14.0177V12.0002L20.0178 14.4002L26.0179 12.0002V11.8658C25.9988 5.32043 20.6975 0.0191087 14.1521 0Z",
    fill: "#FF8F6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0164 11.9998V12.1318C25.9976 18.6786 20.695 23.9812 14.1482 24H13.8842C7.33736 23.9812 2.03478 18.6786 2.01599 12.1318V11.9998H26.0164Z",
    fill: "#D35230"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.6162 5.89807V18.7023C14.6132 19.1472 14.3436 19.5469 13.9322 19.7163C13.8012 19.7717 13.6604 19.8003 13.5182 19.8003H4.84805C4.68005 19.6083 4.51805 19.4043 4.36804 19.2003C2.8394 17.1611 2.01402 14.6807 2.016 12.1322V11.8682C2.0125 9.56942 2.68432 7.32028 3.94804 5.40006C4.08004 5.19606 4.21803 4.99205 4.36804 4.80005H13.5182C14.1227 4.80463 14.6116 5.29356 14.6162 5.89807Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.0162 6.49768V19.3019C14.0162 19.4441 13.9876 19.5849 13.9322 19.7159C13.7628 20.1273 13.3631 20.3969 12.9182 20.3999H5.39406C5.20423 20.2072 5.02207 20.007 4.84805 19.7999C4.68005 19.6079 4.51805 19.4039 4.36804 19.1999C2.83939 17.1607 2.01402 14.6803 2.016 12.1318V11.8678C2.0125 9.56902 2.68432 7.31988 3.94804 5.39966H12.9182C13.5227 5.40422 14.0116 5.89316 14.0162 6.49768Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.0162 6.49767V18.1019C14.0116 18.7064 13.5227 19.1953 12.9182 19.1999H4.36804C2.8394 17.1607 2.01402 14.6803 2.016 12.1318V11.8678C2.0125 9.56902 2.68432 7.31988 3.94804 5.39966H12.9182C13.5227 5.40421 14.0116 5.89314 14.0162 6.49767Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.4162 6.49767V18.1019C13.4116 18.7064 12.9227 19.1953 12.3182 19.1999H4.36804C2.8394 17.1607 2.01402 14.6803 2.016 12.1318V11.8678C2.0125 9.56902 2.68432 7.31988 3.94804 5.39966H12.3182C12.9227 5.40421 13.4116 5.89314 13.4162 6.49767Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.31661 5.39966H12.3172C12.9246 5.39966 13.417 5.89207 13.417 6.49947V17.5001C13.417 18.1075 12.9246 18.5999 12.3172 18.5999H1.31661C0.709208 18.5999 0.216797 18.1075 0.216797 17.5001V6.49947C0.216797 5.89207 0.709208 5.39966 1.31661 5.39966Z",
    fill: "url(#paint0_linear_9125_397307)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9381 8.3323C7.6542 8.28398 8.36413 8.49199 8.94093 8.91912C9.42202 9.34861 9.67907 9.97534 9.63814 10.6189C9.646 11.0663 9.52678 11.5068 9.29434 11.8892C9.05901 12.2649 8.71997 12.5646 8.31812 12.752C7.85871 12.9656 7.35644 13.0711 6.84989 13.0604H5.45847V15.6464H4.03345V8.3323H6.9381ZM5.45728 11.9432H6.6837C7.07251 11.9717 7.45829 11.8567 7.76793 11.6198C8.02403 11.3741 8.15826 11.0276 8.13453 10.6736C8.13453 9.86754 7.66612 9.46453 6.72931 9.46453H5.45729L5.45728 11.9432Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9125_397307",
    x1: 2.50994,
    y1: 4.54028,
    x2: 11.1239,
    y2: 19.4593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA4C28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C5401E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B62F14"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPowerPoint);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/powerPoint.13836df2092fc407e4cad6925c8b7401.svg";